import { render } from "./EditPriorityMatrix.vue?vue&type=template&id=07906ce6"
import script from "./EditPriorityMatrix.vue?vue&type=script&lang=js"
export * from "./EditPriorityMatrix.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__